import type { ProgressBarResponse } from '@skin-seoul/service';

export const SIGN_IN_BANNER_MESSAGE = {
  /** Cart below free shipping threshold */
  belowFreeShipping: ' for Points!',
  /** Free shipping unlocked */
  reachedFreeShipping: ' to earn points on your purchase!',
} as const;

export function getSignInBannerSuffix(progressBar: ProgressBarResponse | null): string {
  if (!progressBar) return SIGN_IN_BANNER_MESSAGE.belowFreeShipping;

  const shippingAvailable = progressBar.freeShipping?.available ?? false;
  if (!shippingAvailable) return SIGN_IN_BANNER_MESSAGE.belowFreeShipping;

  return SIGN_IN_BANNER_MESSAGE.reachedFreeShipping;
}
